import Box from '@material-ui/core/Box';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddEditParts from './AddEditParts';
import TopActions from './TopActions';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, ...contentProps }) => (
  <Box style={{ ...theme.palette.contentStyle }}>
    <Component {...contentProps} />
  </Box>
);

export default Index;

const Component = ({
  partsList,
  Styled,
  fetchParts,
  changeRequest,
  saveParts,
  updateParts,
  callback,
  apiStatus,
  handleDeleteAlert,
  topAction,
  request,
  viewOnly,
}) => {
  const { i18n } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [withCloseIcon, setWithCloseIcon] = useState(true);
  const [backgroundModal, setBackgroundModal] = useState(false);
  const [modalObject, setModalObject] = useState({
    header: '',
    content: () => {},
  });

  const closeModal = () => setModalOpen(false);

  const columns = [
    {
      id: 'partName',
      label: i18n.t('parts.partName'),
      needSorting: true,
    },
    {
      id: 'partsInInventory',
      label: i18n.t('parts.partsInventory'),
      needSorting: true,
    },
    {
      id: 'cost',
      label: i18n.t('parts.cost'),
      needSorting: true,
    },
    ...(!viewOnly
      ? [
          {
            id: 'actions',
            label: i18n.t('common.tools'),
          },
        ]
      : []),
  ];

  const generateRows = () => partsList?.content || [];
  const information = i18n.t('common.tableEmptyMessage');

  const handleEdit = (row) => {
    setWithCloseIcon(true);
    setBackgroundModal(false);
    setModalObject({
      header: '',
      content: () => (
        <AddEditParts closeModal={closeModal} callback={callback} saveParts={updateParts} currentItem={row} Styled={Styled} />
      ),
    });
    setModalOpen(true);
  };

  const handleDelete = (row) => {
    setWithCloseIcon(false);
    setBackgroundModal(true);
    setModalObject({
      content: () => (
        <div className="deleteParent">
          <div className="imageSection">
            <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
          </div>
          <h2 className="departmentConfirm">{i18n.t('common.sureConfirm')}</h2>
          <div className="deletePopupBtn">
            <div className="cancelBtn">
              <Button label={i18n.t('Cancel')} type="reset" onClick={closeModal} />
            </div>
            <div className="deletebtn">
              <Button
                label={i18n.t('common.deletePopup')}
                onClick={() => {
                  handleDeleteAlert({
                    id: 'deleteAlert',
                    data: { id: row.id },
                    callback,
                  });
                  closeModal();
                }}
              />
            </div>
          </div>
        </div>
      ),
    });
    setModalOpen(true);
  };

  return (
    <>
      <Styled.Wrapper>
        {topAction && <TopActions {...{ i18n, saveParts, Styled, callback, request, viewOnly }} />}
        <Styled.TableWrapper>
          <Table
            type="server"
            defaultSortBy={{ sortBy: 'partName', order: 'asc' }}
            baseRequest={request}
            columns={columns}
            changeRequest={changeRequest}
            data={generateRows()}
            emptyMessage={information}
            totalRecords={partsList?.totalElements}
            i18n={i18n}
            actions={
              !viewOnly
                ? [
                    {
                      icon: (row) => <Icon src={mediaUrls?.edit} onClick={() => handleEdit(row)} />,
                    },
                    {
                      icon: (row) => <Icon src={mediaUrls?.deleteIcon} onClick={() => handleDelete(row)} />,
                    },
                  ]
                : []
            }
            itemsPerPage={10}
          />
        </Styled.TableWrapper>
        <Modal
          open={modalOpen}
          setOpen={setModalOpen}
          data={modalObject}
          onCloseModal={closeModal}
          background="black"
          withCloseIcon={withCloseIcon}
          backgroundModal={backgroundModal}
        />
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  partsList: PropTypes.object.isRequired,
  Styled: PropTypes.object.isRequired,
  fetchParts: PropTypes.func.isRequired,
  changeRequest: PropTypes.func.isRequired,
  saveParts: PropTypes.func.isRequired,
  updateParts: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  topAction: PropTypes.bool,
  request: PropTypes.object.isRequired,
  viewOnly: PropTypes.bool,
};
